import { useEffect, useRef, useState } from 'react';

export default function VideoSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative w-full py-24 md:py-32 bg-black overflow-hidden"
    >
      {/* Decorative lines */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16 bg-gradient-to-b from-transparent via-[#EADDCC]/30 to-transparent" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-16 bg-gradient-to-b from-transparent via-[#EADDCC]/30 to-transparent" />

      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <p
            className="text-[#EADDCC]/50 text-xs tracking-widest mb-4 uppercase"
            style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.4em' }}
          >
            Campaign Film
          </p>
          <h2
            className="text-[#EADDCC] text-3xl md:text-5xl font-light italic"
            style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.08em' }}
          >
            The Beast Within
          </h2>
        </div>

        {/* Video Container */}
        <div
          className={`relative transition-all duration-1000 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          {/* Frame decoration */}
          <div className="absolute -inset-4 border border-[#EADDCC]/10 pointer-events-none" />
          <div className="absolute -inset-8 border border-[#EADDCC]/5 pointer-events-none" />

          {/* Video wrapper with aspect ratio */}
          <div className="relative w-full aspect-video bg-[#0a0a0a]">
            <iframe
              src="https://www.youtube.com/embed/UlZBDC7Tc74?rel=0&modestbranding=1"
              title="The Beast Within - Campaign Film"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
              style={{ border: 'none' }}
            />
          </div>

          {/* Caption */}
          <div className="mt-8 text-center">
            <p
              className="text-[#EADDCC]/40 text-sm italic"
              style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.1em' }}
            >
              Where instinct awakens and elegance transforms
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}